import { useCallback, useState } from "react";

/**
 * Conmutador "Por usuario | Por agente" de la pestaña de permisos, con la
 * preferencia recordada. Mismo patron que `vistaAsignaciones.ts` (panel de
 * modelos): `localStorage` porque es una preferencia de la persona, no de la
 * visita, y el valor se VALIDA al leerlo para que uno escrito por otra version
 * no deje la seccion sin pintar ninguna vista.
 *
 * Modulo aparte del componente por `react-refresh/only-export-components`.
 */
export const VISTAS_PERMISOS = ["usuarios", "agentes"] as const;

export type VistaPermisos = (typeof VISTAS_PERMISOS)[number];

export const VISTA_PERMISOS_STORAGE_KEY = "admin_permisos_vista";

const POR_DEFECTO: VistaPermisos = "usuarios";

function esVista(valor: unknown): valor is VistaPermisos {
  return VISTAS_PERMISOS.includes(valor as VistaPermisos);
}

export function useVistaPermisos(): [VistaPermisos, (v: VistaPermisos) => void] {
  const [vista, setVistaState] = useState<VistaPermisos>(() => {
    try {
      const guardada = localStorage.getItem(VISTA_PERMISOS_STORAGE_KEY);
      return esVista(guardada) ? guardada : POR_DEFECTO;
    } catch {
      return POR_DEFECTO;
    }
  });

  const setVista = useCallback((v: VistaPermisos) => {
    setVistaState(v);
    try {
      localStorage.setItem(VISTA_PERMISOS_STORAGE_KEY, v);
    } catch {
      /* localStorage puede lanzar en modo privado; no puede tumbar el panel */
    }
  }, []);

  return [vista, setVista];
}
